import cx from "classnames"
import React, { forwardRef } from "react"
import { Resizable } from "react-resizable"

import styles from "./resizable-column.module.scss"

import type { ResizeCallbackData } from "react-resizable"

interface Props extends React.ThHTMLAttributes<HTMLTableCellElement> {
    width?: number
    onResize?: (e: React.SyntheticEvent<Element>, data: ResizeCallbackData) => void
    dragAreaProps?: React.HTMLAttributes<HTMLDivElement>
    dataIndex?: string
}

export const ResizableColumn = forwardRef<HTMLTableCellElement, Props>(function ResizableColumn(props, ref) {
    const { onResize, width = 100, className, dragAreaProps, children, dataIndex, ...restProps } = props

    const handleResizeMouseDown = (e: React.MouseEvent) => {
        e.stopPropagation()
    }

    return (
        <Resizable
            width={width as number}
            height={0}
            handle={
                <span
                    className={styles["react-resizable-handle"]}
                    onMouseDown={handleResizeMouseDown}
                    onClick={(e) => e.stopPropagation()}
                />
            }
            onResize={onResize}
            draggableOpts={{ enableUserSelectHack: false }}
        >
            <th
                {...restProps}
                ref={ref}
                className={cx(styles["react-resizable"], styles.reactResizable, className)}
                style={{ ...restProps.style, padding: "0 1rem 0 0" }}
            >
                <div
                    {...dragAreaProps}
                    style={{
                        ...dragAreaProps?.style,
                        padding: "1rem 0px 1rem 1rem"
                    }}
                >
                    {children}
                </div>
            </th>
        </Resizable>
    )
})
